export default __webpack_public_path__ + "static/media/phone.a1727f37.svg";